var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "batchActions flex-level" }, [
    _c(
      "div",
      { staticClass: "flex-level pl-2" },
      [
        _c("span", { staticClass: "valign-middle fs-3" }, [
          _vm._v(
            _vm._s(
              _vm.$l10n.n__(
                "%d ligne sélectionnée",
                "%d lignes sélectionnées",
                _vm.totalSelected,
                _vm.totalSelected
              )
            )
          )
        ]),
        _vm._v(" "),
        _c(
          "CompassSelect",
          {
            staticClass: "batch-actions-select",
            attrs: {
              disabled: !_vm.lengthSelection,
              placeholder:
                "— " + _vm.$l10n.__("Choisissez une action à effectuer") + " —",
              menuClass: "batch-actions-select__menu"
            },
            on: { change: _vm.handleChange },
            model: {
              value: _vm.batchAction.name,
              callback: function($$v) {
                _vm.$set(_vm.batchAction, "name", $$v)
              },
              expression: "batchAction.name"
            }
          },
          _vm._l(_vm.batchActionsByUse, function(value, key) {
            return _c(
              "CompassOptionGroup",
              { key: key, attrs: { label: _vm.labelOptionGroup(key) } },
              _vm._l(value, function(action) {
                return _c(
                  "CompassTooltip",
                  {
                    key: action.name,
                    attrs: {
                      content: _vm.$t.__("listing.ListingBatch.action_error"),
                      disabled: _vm.isActiveBatchAction(action)
                    }
                  },
                  [
                    _c(
                      "CompassDropdownSelectOption",
                      {
                        class: _vm.dropdownOptionClass(action.name),
                        attrs: {
                          label: action.label,
                          value: action.action,
                          disabled: !_vm.isActiveBatchAction(action),
                          "data-upsell": action["data-upsell"]
                        }
                      },
                      [
                        _vm._v(
                          "\n                        " +
                            _vm._s(action.label) +
                            "\n                        "
                        ),
                        !_vm.isSubscriptionFeatureEnabled(action.name)
                          ? _c("CompassFeatureBadge", {
                              attrs: { variant: "upsell", size: "small" }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              }),
              1
            )
          }),
          1
        ),
        _vm._v(" "),
        _vm.enableAllPages && _vm.visibleAllPages
          ? _c(
              "el-checkbox",
              {
                staticClass: "flex-level ml-3",
                attrs: { id: "selectAllPages", name: "selectAllPages" },
                model: {
                  value: _vm.checkAllPages,
                  callback: function($$v) {
                    _vm.checkAllPages = $$v
                  },
                  expression: "checkAllPages"
                }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$l10n.__(
                        "Sélectionner toutes les pages (%(count)s éléments)",
                        {
                          count: _vm.pagination.total
                        }
                      )
                    ) +
                    "\n        "
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("CompassButton", {
          staticClass: "right valign-middle ml-3",
          attrs: {
            label: _vm.$t.__("common.actions.validate"),
            type: "primary",
            disabled: !_vm.lengthSelection || !_vm.batchAction.name
          },
          on: { click: _vm.launchAction }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }